/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-constant-condition */
import { useEffect, useState } from "react";
import { useRouteMatch, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import * as MUI from "@mui/material";
import * as Icon from "@mui/icons-material";

import { useAuth } from "../../../hooks/auth";
import {
  getBikePorChassi,
  getFotoDaBike,
} from "../../../services/apiConsultaBike";
import { IConsultaRoute, IDadosBike, IFotoBike } from "../../../interface/bike";

import { LabelInfo } from "../../../components";

const styleInputs = {
  display: "flex",
  flexDirection: "row",
  gap: 1,
};

export const FichaBike: React.FC = () => {
  const history = useHistory();
  const { params } = useRouteMatch<IConsultaRoute>();

  const [dados, setDados] = useState<IDadosBike>();
  const [foto, setFoto] = useState<IFotoBike | null>(null);
  const [foto1, setFoto1] = useState<IFotoBike | null>(null);
  const [loading, setLoading] = useState(true);
  const [msgError, setMsgErro] = useState("");

  const { user } = useAuth();

  const { url } = user!.sistemas.filter((s) => {
    return s.id_sistema === 1 ? s.url : false;
  })[0];

  useEffect(() => {
    async function consultaFichaBike() {
      getBikePorChassi(url, params.CHASSI, params.MARCA, params.ID_BIKE)
        .then((response) => {
          if (response.status === 200) {
            setDados(response.data);
          }
          if (response.status === 404) {
            toast.error("HOUVE ALGUM ERRO NA REQUISIÇÃO, TENTE NOVAMENTE.", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            });
          }
          if (response.status === 500 || response.status === 503) {
            toast.error("ERRO NO SERVIDOR, TENTE MAIS TARDE!", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            });
          }
          if (response.status === 504) {
            toast.error(
              "O SERVIDOR DEMOROU MUITO PARA RESPONDER, TENTE NOVAMENTE EM INSTANTES.",
              {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 4000,
              }
            );
          }
          setLoading(false);
        })
        .catch((err: any) => {
          setLoading(false);
          toast.error("ERRO DE CONEXÃO! VERIFIQUE SUA INTERNET!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
        });
    }
    consultaFichaBike();
  }, []);

  useEffect(() => {
    async function getFoto() {
      await getFotoDaBike(url, params.ID_BIKE).then((response) => {
        if (response.status === 200) {
          setFoto(response.data[0].FOTO);
          setFoto1(response.data[1].FOTO);
        }
        if (response.status === 404) {
          setMsgErro("Sem foto da bike");
        }
        setLoading(false);
      });
    }
    getFoto();
  });

  const imprimir = () => {
    window.print();
  };

  const voltar = () => {
    history.goBack();
  };

  const theme = MUI.useTheme();

  return (
    <MUI.Stack
      pt={[2, 0]}
      flexDirection="row"
      width="100%"
      height="80vh"
      overflow="auto"
      sx={{
        "@media print": {
          overflow: "hidden !important",
          height: "100%",
          pageBreakInside: "avoid",
        },
      }}
    >
      <MUI.Stack p={2} flex={1}>
        <MUI.Stack
          mb={1}
          gap={[1, 0]}
          width={["100%", "95%"]}
          flexDirection={["column", "row"]}
          justifyContent="space-between"
          sx={{
            displayPrint: "none",
          }}
        >
          <MUI.Button
            variant="contained"
            onClick={voltar}
            startIcon={<Icon.KeyboardReturn />}
          >
            Voltar para pesquisa
          </MUI.Button>
          <MUI.Button variant="contained" onClick={imprimir}>
            Imprimir
          </MUI.Button>
        </MUI.Stack>
        {!loading ? (
          <>
            <MUI.Stack
              flex={1}
              mb={1}
              gap={2}
              alignItems="center"
              justifyContent={["center", "inherit"]}
              flexDirection={["column", "row"]}
              sx={{
                "@media print": {
                  flexDirection: "row",
                },
              }}
            >
              {foto && (
                <MUI.Stack height="16rem">
                  <MUI.Avatar
                    imgProps={{
                      sx: {
                        width: "auto",
                        height: "230px",
                        objectFit: "fill",
                      },
                    }}
                    variant="rounded"
                    src={`${foto}`}
                    alt="foto identidade"
                    sx={{
                      width: "auto",
                      height: "230px",
                    }}
                  />
                </MUI.Stack>
              )}
              {foto && (
                <MUI.Stack height="16rem">
                  <MUI.Avatar
                    imgProps={{
                      sx: {
                        width: "auto",
                        height: "230px",
                        objectFit: "contain",
                      },
                    }}
                    variant="rounded"
                    src={`${foto1}`}
                    alt="foto identidade"
                    sx={{
                      width: "auto",
                      height: "230px",
                    }}
                  />
                </MUI.Stack>
              )}
            </MUI.Stack>

            {dados && (
              <MUI.Stack width="97%">
                <MUI.Typography
                  bgcolor={theme.palette.secondary.light}
                  variant="h6"
                >
                  Dados Bike
                </MUI.Typography>
                <MUI.Divider
                  sx={{
                    borderWidth: 1.5,
                    backgroundColor: `${theme.palette.secondary.contrastText}`,
                  }}
                />
                <MUI.Grid container spacing={1} py={1}>
                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Situaçao:"
                      info={dados.SITUACAO || "NÃO INFORMADO"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Chassi nº1:"
                      info={dados.chassi0 || "NÃO INFORMADO"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Chassi nº2:"
                      info={dados.chassi1 || "NÃO INFORMADO"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Chassi nº3:"
                      info={dados.chassi2 || "NÃO INFORMADO"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Chassi nº4:"
                      info={dados.chassi3 || "NÃO INFORMADO"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Chassi nº5:"
                      info={dados.chassi4 || "NÃO INFORMADO"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Marca:"
                      info={dados.MARCA || "NÃO INFORMADO"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Modelo:"
                      info={dados.MODELO || "NÃO INFORMADO"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Cor:"
                      info={dados.COR || "NÃO INFORMADO"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Tipo:"
                      info={dados.TIPO || "NÃO INFORMADO"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Aro:"
                      info={dados.ARO || "NÃO INFORMADO"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} md={12} sm={12} item sx={styleInputs}>
                    <LabelInfo
                      label="Descrição:"
                      info={dados.DESCRICAO || "NÃO INFORMADO"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Proprietário:"
                      info={dados.PROPRIETARIO || "NÃO INFORMADO"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Mãe:"
                      info={dados.NOME_MAE || "NÃO INFORMADO"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Pai:"
                      info={dados.NOME_PAI || "NÃO INFORMADO"}
                    />
                  </MUI.Grid>

                  <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                    <LabelInfo
                      label="Email:"
                      info={dados.EMAIL || "NÃO INFORMADO"}
                    />
                  </MUI.Grid>

                  {(dados && dados.NUMERO_BO === "SEM B.O ABERTO") ||
                  "SEM BO" ? (
                    false
                  ) : (
                    <>
                      <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                        <LabelInfo
                          label="Nº do BO:"
                          info={dados.NUMERO_BO || "NÃO INFORMADO"}
                        />
                      </MUI.Grid>

                      <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                        <LabelInfo
                          label="Data do fato:"
                          info={dados.DATA_FATO || "NÃO INFORMADO"}
                        />
                      </MUI.Grid>

                      <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                        <LabelInfo
                          label="Natureza:"
                          info={dados.NM_NATUREZA_OCORRENCIA || "NÃO INFORMADO"}
                        />
                      </MUI.Grid>

                      <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                        <LabelInfo
                          label="Endereço:"
                          info={dados.NM_LOGRADOURO || "NÃO INFORMADO"}
                        />
                      </MUI.Grid>

                      <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                        <LabelInfo
                          label="Bairro:"
                          info={dados.NM_BAIRRO || "NÃO INFORMADO"}
                        />
                      </MUI.Grid>

                      <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                        <LabelInfo
                          label="Cidade:"
                          info={dados.NM_MUNICIPIO || "NÃO INFORMADO"}
                        />
                      </MUI.Grid>

                      <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                        <LabelInfo
                          label=" Unidade Operacional:"
                          info={dados.NM_UNIDADE_OPERACIONAL || "NÃO INFORMADO"}
                        />
                      </MUI.Grid>

                      <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                        <LabelInfo
                          label="Histórico:"
                          info={dados.DS_HISTORICO || "NÃO INFORMADO"}
                        />
                      </MUI.Grid>
                    </>
                  )}
                </MUI.Grid>
              </MUI.Stack>
            )}
          </>
        ) : (
          <MUI.LinearProgress />
        )}
      </MUI.Stack>
    </MUI.Stack>
  );
};
